module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/PrinceOfPersia_xbox_lrg.f04a328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/PrinceOfPersia_xbox_lrg.jpg
// module id = mt+x
// module chunks = 0